import { debounce } from 'lodash';
import { useMemo, useRef } from 'react';

function useDebouncedCallback<TArgs extends unknown[]>(
  callback: (...args: TArgs) => void,
  delay = 500,
): (...args: TArgs) => void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useMemo(() => debounce((...args: TArgs) => callbackRef.current(...args), delay), [delay]);
}

export default useDebouncedCallback;
